import { Flex, SoftBadge, Tooltip } from '@wyz/ui';
import { Trans } from '~/common/context';

const ListTooltip = ({ list }: { list: Array<string> }) => {
  if (list.length === 0) {
    return <>{'-'}</>;
  }
  if (list.length === 1) {
    return <SoftBadge bg='classic'>{list[0]}</SoftBadge>;
  }

  return (
    <Flex justifyContent='center' alignItems='center' className='space-x-1'>
      <Tooltip label={list.join(', ')}>
        <SoftBadge bg='classic'>
          <Trans
            i18nKey='app.common.items_count'
            values={{ count: list.length }}
          />
        </SoftBadge>
      </Tooltip>
    </Flex>
  );
};

export default ListTooltip;
